import { render, staticRenderFns } from "./B70Report.vue?vue&type=template&id=1c218892&scoped=true"
import script from "./B70Report.ts?vue&type=script&lang=ts&external"
export * from "./B70Report.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c218892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c218892')) {
      api.createRecord('1c218892', component.options)
    } else {
      api.reload('1c218892', component.options)
    }
    module.hot.accept("./B70Report.vue?vue&type=template&id=1c218892&scoped=true", function () {
      api.rerender('1c218892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/reports/B70Report/B70Report.vue"
export default component.exports